// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3X8e4","rootMobile":"styles_rootMobile__1Rcch"};